import { ErrorHandler, Injectable, inject } from '@angular/core'
import { ErrorService } from './error.service'

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
    private errorService = inject(ErrorService)

    handleError(error: Error) {
        this.errorService.set(error)
        throw error
    }
}
